import { Capacitor } from "@capacitor/core";

export function setCookie(name: string, value: string, exp: number, path?: string) {
  if (typeof document !== undefined) {
    const date = new Date();
    date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + value + ";expires=" + date.toUTCString() + ";path=" + (path ?? "/");
  }
}
export function getCookie(name: string) {
  if (typeof window !== "object") return null;
  https: if (typeof document !== "undefined") {
    const value = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
    return value ? value[2] : null;
  } else {
    return null;
  }
}
export function deleteCookie(name: string) {
  if (typeof document !== undefined) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }
}
export function getDefaultScreenStr() {
  const isCapacitor = Capacitor.isNativePlatform();
  const defaultScreen = isCapacitor ? "N" : "N"; //"F"
  return defaultScreen;
}
